<template>
  <transition name="fade">
    <div
      v-if="visible"
      class="fixed bottom-1/2 right-1/2 z-50 w-full max-w-[335px] -translate-y-1/2 translate-x-1/2 lg:max-w-sm"
      role="alert"
    >
      <div
        :class="[
          'relative flex h-full min-h-28 w-full flex-col items-center justify-center  rounded-lg px-5 py-4 text-white shadow-lg',
          typeClass,
        ]"
      >
        <span
          class="mb-4 block text-base font-medium"
          :class="{ 'text-black': isConfirm }"
          >{{ message }}</span
        >

        <div v-if="isConfirm" class="flex justify-end space-x-4">
          <button
            class="rounded bg-red-500 px-4 py-2 text-white"
            @click="cancel"
          >
            Cancel
          </button>
          <button
            class="rounded bg-green-500 px-4 py-2 text-white"
            @click="confirm"
          >
            Confirm
          </button>
        </div>

        <template v-else>
          <button
            class="absolute right-4 top-4 text-xl leading-none hover:opacity-80"
            @click="close"
          >
            &times;
          </button>
        </template>
      </div>
    </div>
  </transition>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, onBeforeUnmount } from "vue";
import { usePopup } from "@/composables/usePopup";

const props = defineProps<{
  message: string;
  type?: "success" | "error" | "info" | "confirm";
  duration?: number;
  popUpId: number;
}>();

const visible = ref(true);
const isConfirm = computed(() => props.type === "confirm");
const { closePopup } = usePopup();

const typeClass = computed(() => {
  switch (props.type) {
    case "success":
      return "bg-green-500";
    case "error":
      return "bg-red-500";
    case "confirm":
      return "bg-white text-black";
    default:
      return "bg-blue-500";
  }
});

function close() {
  visible.value = false;
  setTimeout(() => closePopup(props.popUpId), 300);
}

function confirm() {
  visible.value = false;
  setTimeout(() => closePopup(props.popUpId, true), 300);
}

function cancel() {
  visible.value = false;
  setTimeout(() => closePopup(props.popUpId, false), 300);
}

onMounted(() => {
  if (!isConfirm.value && props.duration !== 0) {
    setTimeout(close, props.duration ?? 3000);
  }

  if (isConfirm.value) {
    document.body.style.overflow = "hidden";
  }
});

onBeforeUnmount(() => {
  document.body.style.overflow = "";
});
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
